import React, { useContext } from 'react';
import { get } from 'lodash';

import AnswersDropdown from 'src/presentation/components/pages/shared/AnswersDropdown';
import { AnswerType } from 'src/presentation/components/pages/shared/hooks/useAnswersFilter';
import { CampaignType } from 'src/actions/campaigns/campaignsResource';
import { campaignTypeToEndpointType } from 'src/presentation/components/pages/proactiveCommunications/constants';
import EndpointsDropdown from 'src/presentation/components/pages/proactiveCommunications/components/shared/EndpointsDropdown';
import FormContext from 'src/presentation/contexts/FormContext';
import LanguagesDropdown from 'src/presentation/components/pages/shared/LanguageDropdown';
import { Row } from 'src/presentation/components/forms/Layout';

const EmailCampaignContentEditor = () => {
  const { workingState } = useContext(FormContext);

  const answerLanguage = get(workingState, 'content.answerLanguage');

  return (
    <>
      <Row>
        <EndpointsDropdown
          data-aid="campaigns-endpoint-dropdown"
          attr="content.endpointId"
          description="The email address used to send the message."
          label="Email address"
          placeholder="Select an email address"
          endpointType={campaignTypeToEndpointType[CampaignType.EMAIL]}
        />
      </Row>

      <Row>
        <LanguagesDropdown attr="content.answerLanguage" />
      </Row>

      <Row>
        <AnswersDropdown
          answerType={AnswerType.EMAIL}
          attr="content.answerId"
          language={answerLanguage}
          description="The Email Answer for your Campaign."
        />
      </Row>
    </>
  );
};

export default EmailCampaignContentEditor;
